<template>
  <div>
    <button
      @click="updateListViewType('list')"
      @keyup.enter="updateListViewType('cards')"
      class="c-btn c-btn--invisible has-icon"
      aria-label="Vis boliger som liste."
    >
      <svg
        :class="{
          'is-active': listType === 'list',
        }"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="c-btn__icon c-btn__icon--toggle c-btn__icon--large"
      >
        <path d="M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z" />
      </svg>
    </button>
    <button
      @click="updateListViewType('cards')"
      @keyup.enter="updateListViewType('cards')"
      class="c-btn c-btn--invisible has-icon"
      aria-label="Vis boliger som kort."
    >
      <svg
        :class="{
          'is-active': listType === 'cards',
        }"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="c-btn__icon c-btn__icon--toggle c-btn__icon--large"
      >
        <path d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z" />
      </svg>
    </button>
  </div>
</template>

<script>
// Models
import Residence from '@/models/Residence';

export default {
  name: 'ListViewSelector',
  computed: {
    listType() {
      return this.$store.state.entities.residences.listType;
    },
    sources() {
      return window.__selector_settings__.sourceData;
    },
  },
  methods: {
    fetchAllWithImages() {
      const hasImages = this.$store.state.entities.residences.hasImages;
      Residence.fetchAllWithImages(
        this.sources.project,
        this.sources.sourceURL,
        this.sources.hiddenId,
        hasImages
      );
      Residence.commit(state => {
        state.hasThumbnails = true;
      });
    },
    updateListViewType(view) {
      Residence.commit(state => {
        state.listType = view;
      });

      if (view === 'cards' && this.$store.state.entities.residences.hasThumbnails === false) {
        this.fetchAllWithImages();
      }

      if (this.$gtag) {
        this.$gtag.event(view, {
          event_category: 'ViewType',
          event_label: view,
        });
      }
    },
  },
};
</script>